import {connect} from 'react-redux'
import _ from 'lodash'

import {AppFooter} from './appfooter.component'
// import { toggleSidebar } from '../planner/planner.action'
import {activateMenuItem} from './appfooter.action'
import {toggleBooking} from '../planner/planner.action'

import {onChangeDetailsUI} from '../details/details.action'
import {activateLeg} from '../leg/leg.action'
import deeplinksUtil from '../util/deeplinks.util'

const mapStateToProps = (state) => {
    // let travelers = state.getIn(['document', 'travelers'])

    return {
        activeMenuItem: state.getIn(['uiState', 'activeMenuItem']),
        isLunaTrip: state.getIn(['lunaTrip', 'isLunaTrip']),
        lunatrip: state.getIn(['lunaTrip', 'trip']),
        activeLeg: state.getIn(['uiState', 'activeLeg']),
    // activeUsers: state.getIn(['socket', 'presence'])
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onActivateMenuItem: (selectedMenuItem) => {
            dispatch(activateMenuItem(selectedMenuItem))
        },
        onToggleBooking: () => {
            dispatch(toggleBooking())
        },
        onActivateItinOverview: () => {
            let deepLinkData = {
                'leg': null,
                'section': 'DESTINATION',
                'subsection': 'OVERVIEW',
                'subdetail': ''
            }
            deeplinksUtil.pushDeepLink('UISTATUS', deepLinkData)
            dispatch(onChangeDetailsUI('DESTINATION', 'OVERVIEW', ''))
            dispatch(activateLeg(null))
        }
    }
}

const AppFooterContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AppFooter)

export default AppFooterContainer
